<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    window.onresize = () => {
      this.$store.state.screenWidth = document.documentElement.clientWidth;
      this.$store.state.screenHeight = document.documentElement.clientHeight;
    };
  },
}
</script>
<style lang="scss"></style>
